import { MaskedNumber } from 'imask';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { AfterViewInit, Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { take } from 'rxjs/operators';
import { MarcaComponent } from 'src/app/marca/marca.component';
import { ComposicaoKitModalComponent } from 'src/app/modals/composicao-kit-modal/composicao-kit-modal.component';
import { Fornecedor } from 'src/app/models/fornecedor';
import { Marca } from 'src/app/models/marca';
import { Familia, Produto, ProdutoDesconto } from 'src/app/models/produto';
import { ProdutoFornecedorValor } from 'src/app/models/produto-fornecedor-valor';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FornecedorService } from 'src/app/services/fornecedor.service';
import { GlobalService } from 'src/app/services/global.service';
import { MarcaService } from 'src/app/services/marca.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { CadastrarDescontoProdutoComponent } from '../cadastrar-desconto-produto/cadastrar-desconto-produto.component';
import { FornecedorModalComponent } from 'src/app/modals/fornecedor-modal/fornecedor-modal.component';
import { AlterarMargemValorFornecedorModalComponent } from 'src/app/modals/alterar-margem-valor-fornecedor-modal/alterar-margem-valor-fornecedor-modal.component';
import { ProdutoCDModalComponent } from 'src/app/modals/produto-cdmodal/produto-cdmodal.component';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { GerenciarClassificacaoPersonalizadaModalComponent } from 'src/app/modals/gerenciar-classificacao-personalizada-modal/gerenciar-classificacao-personalizada-modal.component';
import { EstruturasPersonalizadas } from 'src/app/models/estruturas-personalizadas';
import { PremissasSistema } from 'src/app/models/premissas-sistema';
import { Categoria } from '../../models/categoria';
import { CategoriaService } from '../../services/categoria.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastrar-produto',
  templateUrl: './cadastrar-produto.component.html',
  styleUrls: ['./cadastrar-produto.component.scss'],
})
export class CadastrarProdutoComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('autosize', { static: false }) autosize: CdkTextareaAutosize;

  @ViewChild('produtoForm', { static: false }) produtoForm: HTMLFormElement;
  // variáveis
  idProduto;
  produto = new Produto();
  editando = false;
  carregando = true;
  margemParaExibir;
  idProdutoDuplicado;

  tabAlvo = 0;
  tabIndex = 0;

  codErpConectorPainelNaoExiste = false;

  Number = Number;

  podeAlterarEstoque = false;

  usarReservaManual = false;

  travaMargem = true;
  travaPreco = true;
  duplicando = false;
  nomeArquivo = '';

  public MASKS = MASKS;
  editavel = true;
  pegouFranquia = false;
  tiposDeStatus = [
    { id: 'B', nome: 'Bloqueado' },
    { id: 'A', nome: 'Ativo' },
  ];

  tiposAtualizaErp = [
    { id: 'S', nome: 'Sim' },
    { id: 'N', nome: 'Não' },
  ];

  statusSelecionado = 'A';
  familias: Familia[] = [];
  tiposDePesavel = [
    { id: 'N', nome: 'Inteiro' },
    { id: 'F', nome: 'Fracionado' },
    { id: 'S', nome: 'Serviço' },
    // { id: 'P', nome: 'Painel' },
  ];

  visibilidades = [
    { id: 0, nome: 'Todos' },
    { id: 1, nome: 'Vendedor' },
  ];

  pesavelSelecionado = undefined;
  marcas: Marca[] = [];
  marcaSelecionado = undefined;
  fornecedores: Fornecedor[] = [];

  telhados: any[] = [];

  multiFornecedores = false;
  precosFornecedores: ProdutoFornecedorValor[] = [];

  public config: PerfectScrollbarConfigInterface = {};
  public readonly MaskedNumber = MaskedNumber;

  descontosDoProduto: ProdutoDesconto[] = [];

  selectedFile: File;

  administrador = false;

  possuiOrcamentoPedido = false;

  tensoes = [
    { id: 1, nome: '220' },
    { id: 2, nome: '380' },
    { id: 3, nome: '440' },
    { id: 4, nome: '800' },
  ];
  erroTensaoSelecionada = false;
  fases = [
    { id: 0, nome: 'Monofásica' },
    // { id: 1, nome: 'Bifásica' },
    { id: 2, nome: 'Trifásica' },
  ];
  tiposInv = [
    { id: 0, nome: 'String' },
    { id: 1, nome: 'Micro' },
    { id: 2, nome: 'Híbrido' },
  ];

  nacionalidades = [
    { id: 0, nome: 'Nacional' },
    { id: 1, nome: 'Importado' },
  ];

  erroFaseSelecionada = false;
  usarCentroDeDistribuicao = false;
  usarVendaProgramada = false;
  pUsarEstoqueMinimo = false;

  usarMarketPlace = false;

  verCustos = 'N';

  modulosAtivos: Number[] = [];

  podeVerEstoque = false;

  estruturasPersonalizadas: EstruturasPersonalizadas = new EstruturasPersonalizadas();

  lojaDeProdutos: boolean = false;

  menus = [
    { id: 0, nome: 'Kit Fechado', disabled: false },
    { id: 1, nome: 'Kit Plus', disabled: false },
    { id: 2, nome: 'Kit Plus 2', disabled: false },
  ];
  menuSelecionado = 0;

  premissasSistema: PremissasSistema = new PremissasSistema();

  categorias: Categoria[] = [];

  constructor(
    private _ngZone: NgZone,
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private produtoService: ProdutoService,
    private router: Router,
    private carregandoService: CarregandoService,
    private globalService: GlobalService,
    private marcaService: MarcaService,
    public dialog: MatDialog,
    private utilitarioService: UtilitarioService,
    private fornecedorService: FornecedorService,
    private premissasService: PremissasService,
    private funcionarioService: FuncionarioService,
    private categoriaService: CategoriaService,
  ) {
    if (this.router.getCurrentNavigation().extras.state && this.router.getCurrentNavigation().extras.state.idProduto) {
      this.duplicando = true;
      this.idProduto = this.router.getCurrentNavigation().extras.state.idProduto;
      this.idProdutoDuplicado = this.idProduto;
    }
  }

  async ngOnInit() {
    const userId = await (await this.globalService.consultaUsuario()).id;

    this.buscarPodeAlterarEstoque();
    this.buscarModulosAtivos();
    this.buscarUsarMarketPlace();
    this.buscarPremissaUsarEstoqueMinimo();
    this.buscarUsarTelhadoCeramico();
    this.buscarFamilias();
    this.buscarCategorias();
    this.buscarUsarReservaManual();
    this.consultaPodeVerEstoque(userId);
    this.buscarPremissaVendaProgramada();
    this.buscarPremissasSistema();

    this.administrador = await this.globalService.administrador();

    this.verCustos = (await this.globalService.consultaUsuario()).verCustos;

    this.lojaDeProdutos = (await this.premissasService.consultarUsarLojaProdutos().toPromise()).valor;

    // se houver id, busca o produto referente
    if (this.idProduto) {
      this.editando = true;
      this.buscarProduto();
    } else if (this.route.snapshot.paramMap.get('id')) {
      this.idProduto = this.route.snapshot.paramMap.get('id');
      this.buscarPossuiOrcamentoPedido();
      this.editando = true;
      this.buscarProduto();
    } else {
      this.produto = new Produto();
      this.produto.margem = undefined;
      this.atualizaDadosProduto();
    }

    this.buscarPremissaCentroDeDistribuicao();
  }

  async buscarNomesMenus() {
    try {
      const nomeKitFechado = await this.premissasService.textoKitFechado().toPromise();
      this.menus[0].nome = nomeKitFechado.texto;

      if (this.premissasSistema.usarNovoMenuKitPronto) {
        const nomeNovoKitPronto = await this.premissasService.textoNovoKitPronto().toPromise();
        this.menus[1].nome = nomeNovoKitPronto.texto;
      } else {
        this.menus[1].disabled = true;
      }

      if (this.premissasSistema.usarKitPlus2) {
        const nomeKitPlus2 = await this.premissasService.textoNovoKitPlus2().toPromise();
        this.menus[2].nome = nomeKitPlus2.texto;
      } else {
        this.menus[2].disabled = true;
      }

      this.menus = [...this.menus];
    } catch (error) {
      console.error('Erro ao buscar nomes dos menus:', error);
      this.notificacaoService.erro('Não foi possível carregar os nomes dos menus.');
    }
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');

    this.premissasService.consultarPremissasSistema().subscribe(
      async (premissas) => {
        this.premissasSistema = premissas;
        this.carregandoService.esconde('buscarPremissasSistema');

        await this.buscarNomesMenus();
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      },
    );
  }

  consultaPodeVerEstoque(id: number) {
    this.carregandoService.mostra('podeVerEstoque');
    this.funcionarioService.consultaPodeVerEstoque(id).subscribe(
      (resp) => {
        this.podeVerEstoque = resp;
        this.carregandoService.esconde('podeVerEstoque');
      },
      (erro) => {
        this.carregandoService.esconde('podeVerEstoque');
        console.error(erro);
        this.notificacaoService.erro('Não foi possível verificar se o usuário pode ver o estoque.');
      },
    );
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      (centro) => {
        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');

        if (centro.valor) {
          this.usarCentroDeDistribuicao = true;
          this.buscarPrecosFornecedores();
        }
      },
      (err) => {
        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
        this.notificacaoService.erro(err);
      },
    );
  }

  buscarPremissaVendaProgramada() {
    this.carregandoService.mostra('buscarPremissaVendaProgramada');
    this.premissasService.consultarVendaProgramada().subscribe(
      (vendaProgramada) => {
        this.carregandoService.esconde('buscarPremissaVendaProgramada');

        if (vendaProgramada.valor) {
          this.usarVendaProgramada = true;
        }
      },
      (err) => {
        this.carregandoService.esconde('buscarPremissaVendaProgramada');
        this.notificacaoService.erro(err);
      },
    );
  }

  buscarPremissaUsarEstoqueMinimo() {
    this.carregandoService.mostra('buscarPremissaUsarEstoqueMinimo');
    this.premissasService.consultarUsarEstoqueMinimo().subscribe(
      (centro) => {
        this.carregandoService.esconde('buscarPremissaUsarEstoqueMinimo');

        if (centro.valor) {
          this.pUsarEstoqueMinimo = true;
        }
      },
      (err) => {
        this.carregandoService.esconde('buscarPremissaUsarEstoqueMinimo');
        this.notificacaoService.erro(err);
      },
    );
  }

  buscarUsarTelhadoCeramico() {
    this.carregandoService.mostra('consultarEstruturasPersonalizadas');
    this.premissasService.consultarEstruturasPersonalizadas().subscribe(
      (dados) => {
        this.estruturasPersonalizadas = dados;

        this.carregandoService.mostra('consultarUsarTelCeramico');
        this.premissasService.consultarUsarTelCeramico().subscribe(
          (f) => {
            this.telhados = [];

            if (f.valor) {
              this.telhados = [
                ...[
                  { id: 11, nome: 'Sem Estrutura' },
                  { id: 0, nome: 'Cerâmico' },
                  { id: 1, nome: 'Fibrocimento' },
                  { id: 8, nome: this.estruturasPersonalizadas.textoFibrometal },
                  { id: 4, nome: 'Metálico' },
                  { id: 7, nome: 'Mini trilho ' },
                  { id: 5, nome: 'Laje' },
                  { id: 6, nome: 'Solo' },
                ],
              ];
            } else {
              this.telhados = [
                ...[
                  { id: 11, nome: 'Sem Estrutura' },
                  { id: 9, nome: 'Colonial' },
                  { id: 10, nome: 'Romana/Americana' },
                  { id: 1, nome: 'Fibrocimento' },
                  { id: 8, nome: this.estruturasPersonalizadas.textoFibrometal },
                  { id: 4, nome: 'Metálico' },
                  { id: 7, nome: 'Mini trilho ' },
                  { id: 5, nome: 'Laje' },
                  { id: 6, nome: 'Solo' },
                ],
              ];
            }

            if (this.estruturasPersonalizadas.usarEstruturaCalhetao) {
              this.telhados.push({ id: 12, nome: this.estruturasPersonalizadas.textoEstruturaCalhetao });
            }

            if (this.estruturasPersonalizadas.usarEstruturaCarport) {
              this.telhados.push({ id: 13, nome: this.estruturasPersonalizadas.textoEstruturaCarport });
            }

            this.carregandoService.esconde('consultarUsarTelCeramico');
          },
          (erro) => {
            this.carregandoService.esconde('consultarUsarTelCeramico');
            this.notificacaoService.erro(erro);
          },
        );

        this.carregandoService.esconde('consultarEstruturasPersonalizadas');
      },
      (erro) => {
        this.carregandoService.esconde('consultarEstruturasPersonalizadas');
        this.notificacaoService.erro(erro);
      },
    );
  }

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable.pipe(take(1)).subscribe(() => this.autosize.resizeToFitContent(true));
  }

  buscarProduto() {
    this.buscarMultiFornecedores();

    this.carregandoService.mostra('buscaProduto');

    this.produtoService.consultarPorId(this.idProduto, null, null, null, false).subscribe(
      (prod) => {
        // if (prod.margem) {
        //   prod.margem = prod.margem.toString().replace(',', '.');
        // }
        this.produto = prod;
        this.produto.tamanho = prod.tamanho != null && prod.tamanho != undefined ? prod.tamanho.toString() : '0';
        this.produto.peso = prod.peso != null && prod.peso != undefined ? prod.peso.toString() : '0';
        this.menuSelecionado = prod.menuOrigem;

        // this.produto.margem = this.produto.margem.toString().replace(',', '.');
        this.buscarDescontosDoProduto();
        this.atualizaDadosProduto();
      },
      (erro) => {
        this.carregandoService.esconde('buscaProduto');
        this.notificacaoService.erro(erro);
      },
    );
  }

  buscarPossuiOrcamentoPedido() {
    this.carregandoService.mostra('buscarPossuiOrcamentoPedido');

    this.produtoService.consultarPossuiOrcamentoPedido(this.idProduto).subscribe(
      (prod) => {
        this.possuiOrcamentoPedido = prod;
        this.carregandoService.esconde('buscarPossuiOrcamentoPedido');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPossuiOrcamentoPedido');
        this.notificacaoService.erro(erro);
      },
    );
  }

  buscarMarcas() {
    this.carregandoService.mostra('buscaMarcas');

    this.marcaService.consultarMarcas().subscribe(
      (marcs) => {
        this.marcas = marcs;

        this.marcaSelecionado = this.marcas.find((s) => s.idMarca === this.produto.marca)
          ? this.marcas.find((s) => s.idMarca === this.produto.marca).idMarca
          : undefined;

        this.carregandoService.esconde('buscaMarcas');
      },
      (erro) => {
        this.carregandoService.esconde('buscaMarcas');
        this.notificacaoService.erro(erro);
      },
    );
  }

  buscarFornecedores() {
    this.carregandoService.mostra('buscarFornecedores');

    this.fornecedorService.consultarFornecedores().subscribe(
      (forns) => {
        this.fornecedores = forns;
        this.carregandoService.esconde('buscarFornecedores');
      },
      (erro) => {
        this.carregandoService.esconde('buscarFornecedores');
        this.notificacaoService.erro(erro);
      },
    );
  }

  buscarFamilias() {
    this.carregandoService.mostra('buscarFamilias');

    this.produtoService.consultarFamilias().subscribe(
      (famis) => {
        this.familias = famis;

        this.carregandoService.esconde('buscarFamilias');
      },
      (erro) => {
        this.carregandoService.esconde('buscarFamilias');
        this.notificacaoService.erro(erro);
      },
    );
  }

  buscarCategorias() {
    this.carregandoService.mostra('buscarCategoias');
    this.categoriaService.listar().subscribe(
      (data) => {
        this.categorias = data;
        this.carregandoService.esconde('buscarCategoias');
      },
      (erro) => {
        this.carregandoService.esconde('buscarCategoias');
        this.notificacaoService.erro(erro);
      },
    );
  }

  buscarDescontosDoProduto() {
    this.carregandoService.mostra('buscaDescontos');

    this.produtoService.consultarDescontos(this.idProduto).subscribe(
      (descs) => {
        this.descontosDoProduto = descs;
        this.descontosDoProduto.forEach((p) => {
          p.situacao = 0;
          if (this.duplicando) {
            p.produto = undefined;
            p.situacao = 1;
            p.idDesc = undefined;
          }
        });

        this.carregandoService.esconde('buscaDescontos');
      },
      (erro) => {
        this.carregandoService.esconde('buscaDescontos');
        this.notificacaoService.erro(erro);
      },
    );
  }

  excluirDesconto(desconto: ProdutoDesconto) {
    desconto.situacao = 2;
  }

  excluirTodosDescontos() {
    if (this.descontosDoProduto && this.descontosDoProduto.length > 0) {
      swal({
        title: 'Deseja realmente Excluir todos os Descontos?',
        text: '',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        buttonsStyling: false,
        type: 'warning',
      }).then((result) => {
        if (result.value) {
          this.descontosDoProduto.forEach((p) => {
            p.situacao = 2;
          });
        }
      });
    }
  }

  novoDesconto() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(CadastrarDescontoProdutoComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: { produtoDesconto: new ProdutoDesconto(), descontos: this.descontosDoProduto, podeLote: true },
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe((result: ProdutoDesconto) => {
      if (result) {
        if (result.emLote) {
          const qtd = Number(result.qtdFim) - Number(result.qtdIni);
          const valorAcrescimo = Number(
            ((Number(result.descontoFinal) - Number(result.descontoInicial)) / qtd).toFixed(14),
          );
          let valorDesco = Number(result.descontoInicial);
          const valorAcrescimoCusto = 0; // Number(((Number(result.descontoFinalCusto) - Number(result.descontoInicialCusto)) / (qtd)).toFixed(14));
          let valorDescoCusto = 0; // Number(result.descontoInicialCusto);

          for (let i = Number(result.qtdIni); i <= Number(result.qtdFim); i++) {
            const novoDesc = new ProdutoDesconto();
            novoDesc.situacao = 1;
            novoDesc.qtdIni = i;
            novoDesc.qtdFim = i;
            novoDesc.desco = this.utilitarioService.toFixedNoRounding(valorDesco, 4);
            novoDesc.descoCusto = 0; // this.utilitarioService.toFixedNoRounding(valorDescoCusto, 4);
            this.descontosDoProduto.push(novoDesc);
            valorDesco += valorAcrescimo;
            valorDescoCusto += valorAcrescimoCusto;

            valorDesco = Number(valorDesco.toFixed(14));
            valorDescoCusto = Number(valorDescoCusto.toFixed(14));
          }
        } else {
          result.situacao = 1;
          this.descontosDoProduto.push(result);
        }

        this.ordenaDescontos();
      }
    });
  }

  editarDesconto(desconto: ProdutoDesconto) {
    const descontoParaEditar = new ProdutoDesconto();

    Object.assign(descontoParaEditar, desconto);

    descontoParaEditar.desco = Number(descontoParaEditar.desco);
    descontoParaEditar.descoCusto = Number(descontoParaEditar.descoCusto);

    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(CadastrarDescontoProdutoComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: {
        produtoDesconto: descontoParaEditar,
        descontos: this.descontosDoProduto.filter((p) => p !== desconto),
        podeLote: false,
      },
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe((result: ProdutoDesconto) => {
      if (result) {
        desconto.qtdIni = result.qtdIni;
        desconto.qtdFim = result.qtdFim;
        desconto.desco = result.desco;
        desconto.descoCusto = 0; // result.descoCusto;
        desconto.situacao = 1;

        this.ordenaDescontos();
      }
    });
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  atualizaDadosProduto() {
    this.statusSelecionado = this.tiposDeStatus.find((s) => s.id === this.produto.situacao)
      ? this.tiposDeStatus.find((s) => s.id === this.produto.situacao).id
      : 'A';

    this.pesavelSelecionado = this.tiposDePesavel.find((s) => s.id === this.produto.pesavel)
      ? this.tiposDePesavel.find((s) => s.id === this.produto.pesavel).id
      : undefined;

    this.buscarMarcas();
    this.buscarFornecedores();

    if (this.duplicando) {
      this.idProduto = '';
      this.produto.idProduto = undefined;
      this.produto.codBarra = '';
    }

    this.carregandoService.esconde('buscaProduto');
    this.carregando = false;
  }

  async salvar() {
    this.carregandoService.mostra('salvaProduto');
    this.produto.pesavel = this.produto.familia === 2 || this.produto.familia === 7 ? 'P' : this.pesavelSelecionado;
    this.produto.situacao = this.statusSelecionado;
    this.produto.marca = this.marcaSelecionado;

    if (this.produto.tensao === undefined || this.produto.tensao === null) {
      this.erroTensaoSelecionada = true;
    }

    if (!this.idProduto) {
      this.produto.qtEstoque = 0;
      this.produto.estoque = 'S';
      this.produto.cc = 11;
      this.produto.fornecedor = '0';
      this.produto.franquia = 0;
      this.produto.setor = 1;
      this.produto.grupo = 1;
    }

    this.produto.dataPreco = new Date();
    this.produto.horaPreco = new Date().toTimeString();

    if (this.produto.familia !== 2 && this.produto.familia !== 7) {
      this.produto.noct = 0;
      this.produto.coefPmax = 0;
    }

    if (this.produto.familia !== 2 && this.produto.familia !== 7 && this.produto.familia !== 8) {
      this.produto.potencia = 0;
      this.produto.tamanho = 1;
    }

    if (this.produto.familia !== 2 && this.produto.familia !== 3) {
      this.descontosDoProduto.forEach((p) => {
        p.situacao = 2;
      });
    }

    this.produto.unidade = this.produto.unidade ? this.produto.unidade : 'UN';
    this.produto.margem = this.produto.margem ? this.produto.margem : 0;
    this.produto.maxDe = this.produto.maxDe ? this.produto.maxDe : 0;

    if (this.produto.fornecedores && this.produto.fornecedores !== null) {
      this.produto.fornecedores = this.produto.fornecedores.map((p) => Number(p));
    }

    if (!this.idProduto && this.produto.foto) {
      this.produto.idProdutoDuplicado = this.idProdutoDuplicado;
    }

    if (!this.idProduto && (this.multiFornecedores || this.usarCentroDeDistribuicao)) {
      this.produto.precoAvulso = 0;
      this.produto.precoCusto = 0;
      this.produto.precoVenda = 0;
      this.produto.margem = 0;
    }

    if (!this.pUsarEstoqueMinimo || this.multiFornecedores || this.usarCentroDeDistribuicao) {
      this.produto.qtEstoqueMinimo = Number();
    }

    if (this.produto.precoCusto === null || this.produto.precoCusto === undefined) {
      this.produto.precoCusto = 0;
    }

    const produtoParaSalvar = Object.assign({}, this.produto);

    produtoParaSalvar.descontos = this.descontosDoProduto;
    produtoParaSalvar.precoCusto = Number(produtoParaSalvar.precoCusto);
    produtoParaSalvar.precoVenda = Number(produtoParaSalvar.precoVenda);
    produtoParaSalvar.precoAvulso = Number(produtoParaSalvar.precoAvulso);

    if (produtoParaSalvar.ipi === null || produtoParaSalvar.ipi === undefined) {
      produtoParaSalvar.ipi = 0;
    } else {
      produtoParaSalvar.ipi = Number(produtoParaSalvar.ipi);
    }

    if (this.pUsarEstoqueMinimo) {
      produtoParaSalvar.qtEstoqueMinimo =
        produtoParaSalvar.qtEstoqueMinimo !== undefined && this.produto.qtEstoqueMinimo !== null
          ? Number(produtoParaSalvar.qtEstoqueMinimo)
          : 0;
    }

    if (this.podeAlterarEstoque && !this.usarCentroDeDistribuicao && !this.multiFornecedores) {
      produtoParaSalvar.qtEstoque = Number(produtoParaSalvar.qtEstoque);
    }

    if (produtoParaSalvar.potencia !== undefined && produtoParaSalvar.potencia !== null) {
      produtoParaSalvar.potencia = Number(produtoParaSalvar.potencia);
    }

    if (produtoParaSalvar.tamanho !== undefined && produtoParaSalvar.tamanho !== null) {
      produtoParaSalvar.tamanho = Number(produtoParaSalvar.tamanho);
    }

    if (produtoParaSalvar.largura !== undefined && produtoParaSalvar.largura !== null) {
      produtoParaSalvar.largura = Number(produtoParaSalvar.largura);
    }

    if (produtoParaSalvar.peso !== undefined && produtoParaSalvar.peso !== null) {
      produtoParaSalvar.peso = Number(produtoParaSalvar.peso);
    }
    if (produtoParaSalvar.altura !== undefined && produtoParaSalvar.altura !== null) {
      produtoParaSalvar.altura = Number(produtoParaSalvar.altura);
    }
    if (produtoParaSalvar.comprimento !== undefined && produtoParaSalvar.comprimento !== null) {
      produtoParaSalvar.comprimento = Number(produtoParaSalvar.comprimento);
    }
    if (produtoParaSalvar.eficiencia !== undefined && produtoParaSalvar.eficiencia !== null) {
      produtoParaSalvar.eficiencia = Number(produtoParaSalvar.eficiencia);
    }
    if (produtoParaSalvar.imp !== undefined && produtoParaSalvar.imp !== null) {
      produtoParaSalvar.imp = Number(produtoParaSalvar.imp);
    }
    if (produtoParaSalvar.isc !== undefined && produtoParaSalvar.isc !== null) {
      produtoParaSalvar.isc = Number(produtoParaSalvar.isc);
    }
    if (produtoParaSalvar.tensao !== undefined && produtoParaSalvar.tensao !== null) {
      produtoParaSalvar.tensao = Number(produtoParaSalvar.tensao);
    }
    if (produtoParaSalvar.tipoLigacaoInv !== undefined && produtoParaSalvar.tipoLigacaoInv !== null) {
      produtoParaSalvar.tipoLigacaoInv = Number(produtoParaSalvar.tipoLigacaoInv);
    }
    if (produtoParaSalvar.tipoInv !== undefined && produtoParaSalvar.tipoInv !== null) {
      produtoParaSalvar.tipoInv = Number(produtoParaSalvar.tipoInv);
    }
    if (produtoParaSalvar.potSaidaInv !== undefined && produtoParaSalvar.potSaidaInv !== null) {
      produtoParaSalvar.potSaidaInv = Number(produtoParaSalvar.potSaidaInv);
    }
    if (produtoParaSalvar.potEntradaInv !== undefined && produtoParaSalvar.potEntradaInv !== null) {
      produtoParaSalvar.potEntradaInv = Number(produtoParaSalvar.potEntradaInv);
    }
    if (produtoParaSalvar.mpptInv !== undefined && produtoParaSalvar.mpptInv !== null) {
      produtoParaSalvar.mpptInv = Number(produtoParaSalvar.mpptInv);
    }
    if (produtoParaSalvar.entradasInv !== undefined && produtoParaSalvar.entradasInv !== null) {
      produtoParaSalvar.entradasInv = Number(produtoParaSalvar.entradasInv);
    }
    if (produtoParaSalvar.entradasSb !== undefined && produtoParaSalvar.entradasSb !== null) {
      produtoParaSalvar.entradasSb = Number(produtoParaSalvar.entradasSb);
    }
    if (produtoParaSalvar.saidasSb !== undefined && produtoParaSalvar.saidasSb !== null) {
      produtoParaSalvar.saidasSb = Number(produtoParaSalvar.saidasSb);
    }

    if (produtoParaSalvar.telhado !== undefined && produtoParaSalvar.telhado !== null) {
      produtoParaSalvar.telhado = Number(produtoParaSalvar.telhado);
    }

    if (produtoParaSalvar.nacionalidade !== undefined && produtoParaSalvar.nacionalidade !== null) {
      produtoParaSalvar.nacionalidade = Number(produtoParaSalvar.nacionalidade);
    }

    produtoParaSalvar.menuOrigem = this.menuSelecionado;

    if (produtoParaSalvar.descontos && produtoParaSalvar.descontos !== null) {
      produtoParaSalvar.descontos.forEach((p) => {
        ((p.desco = Number(p.desco)),
          (p.descoCusto = Number(p.descoCusto)),
          (p.qtdIni = Number(p.qtdIni)),
          (p.qtdFim = Number(p.qtdFim)));
      });
    }

    const produtoFormData = new FormData();
    produtoFormData.append('produto', JSON.stringify(produtoParaSalvar));
    produtoFormData.append('file', this.selectedFile);

    this.produtoService.salvar(produtoFormData).subscribe(
      (retorno) => {
        this.idProduto = retorno.toString();

        this.carregandoService.esconde('salvaProduto');

        swal({
          title: 'Produto salvo com sucesso!',
          text: 'Deseja continuar editando?',
          type: 'success',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.forceReload(`/configuracoes/produtos/editar/${this.idProduto}`);
          } else {
            this.router.navigate(['/configuracoes/produtos']);
          }
        });
      },
      (erro) => {
        this.carregandoService.esconde('salvaProduto');
        this.notificacaoService.erro(erro);
      },
    );
  }

  forceReload(url: string) {
    this.router.navigateByUrl('/configuracoes/produtos', { skipLocationChange: true }).then(() => {
      this.router.navigate([url]);
    });
  }

  travarMargem() {
    this.travaPreco = false;
    this.travaMargem = true;
  }

  travarPreco() {
    this.travaMargem = false;
    this.travaPreco = true;
  }

  calcularMargem() {
    if (this.travaPreco || this.carregando) {
      return;
    }

    const pCusto = this.produto.precoCusto ? Number(this.produto.precoCusto) : 0;
    const pVenda = this.produto.precoVenda ? Number(this.produto.precoVenda) : 0;

    let margem = ((pVenda - pCusto) * 100) / pCusto;

    if (!margem || isNaN(margem) || margem === Infinity) {
      margem = 0;
    }

    this.produto.margem = Number(margem.toFixed(5));
  }

  calcularPrecoVenda() {
    if (this.travaMargem || this.carregando) {
      return;
    }

    const pCusto = this.produto.precoCusto ? Number(this.produto.precoCusto) : 0;
    const pMargem = this.produto.margem ? Number(this.produto.margem) : 0;

    let precoVenda = pCusto + (pCusto * pMargem) / 100;

    if (!precoVenda || isNaN(precoVenda) || precoVenda === Infinity) {
      precoVenda = 0;
    }

    this.produto.precoVenda = Number(precoVenda.toFixed(2));
  }

  onFileChanged(event) {
    this.produto.fotoUrlAnterior = this.produto.fotoUrl;
    this.produto.fotoUrl = null;
    this.produto.foto = null;
    this.selectedFile = event.target.files[0];
  }

  excluirArquivo() {
    this.produto.fotoUrlAnterior = this.produto.fotoUrl;
    this.produto.fotoUrl = null;
    this.produto.foto = null;
    this.selectedFile = undefined;
  }

  buscaDescontosAtivos() {
    return this.descontosDoProduto.filter((p) => p.situacao !== 2);
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }

  ngOnDestroy(): void {}

  ordenaDescontos() {
    this.descontosDoProduto = this.descontosDoProduto.sort((a, b) => {
      return this.compare(Number(a.qtdIni), Number(b.qtdIni), true);
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  abrirMarcas() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(MarcaComponent, {
      width: $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.buscarMarcas();
    });
  }

  abrirFornecedores() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(FornecedorModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.buscarFornecedores();
    });
  }

  selecionarTensao() {
    this.erroTensaoSelecionada = false;
  }

  abrirComposicao() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(ComposicaoKitModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {
        bloquear: this.possuiOrcamentoPedido,
        composicao:
          this.produto.composicao !== null && this.produto.composicao !== undefined
            ? this.produto.composicao.map((p) => Object.assign({}, p))
            : [],
      },
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.produto.composicao = result;
        if (this.produto.composicao.length > 0) {
          if (this.produto && this.produto.obs && this.produto.obs.length > 0) {
            swal({
              title: 'Deseja atualizar a especificação do produto?',
              text: '',
              showCancelButton: true,
              confirmButtonClass: 'btn btn-info',
              cancelButtonClass: 'btn btn-danger',
              confirmButtonText: 'Sim',
              cancelButtonText: 'Não',
              buttonsStyling: false,
              type: 'warning',
            }).then((result) => {
              if (result.value) {
                let texto = '';
                this.produto.composicao.forEach((element, i) => {
                  texto =
                    texto +
                    element.qt +
                    ' ' +
                    element.produtoMP.descricao +
                    (i !== this.produto.composicao.length - 1 ? '\n' : '');
                });
                this.produto.obs = texto;
              }
            });
          } else {
            let texto = '';
            this.produto.composicao.forEach((element, i) => {
              texto =
                texto +
                element.qt +
                ' ' +
                element.produtoMP.descricao +
                (i !== this.produto.composicao.length - 1 ? '\n' : '');
            });
            this.produto.obs = texto;
          }
        }
      }
    });
  }

  buscarMultiFornecedores() {
    this.carregandoService.mostra('buscarMultiFornecedores');
    this.premissasService.consultarMultiFornecedores().subscribe(
      (f) => {
        this.multiFornecedores = f.valor;

        if (this.multiFornecedores) {
          this.buscarPrecosFornecedores();
        }

        this.carregandoService.esconde('buscarMultiFornecedores');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMultiFornecedores');
        this.notificacaoService.erro(erro);
      },
    );
  }

  buscarUsarMarketPlace() {
    this.carregandoService.mostra('buscarUsarMarketPlace');
    this.premissasService.consultarUsarMarketPlace().subscribe(
      (fg) => {
        if (fg.valor) {
          this.usarMarketPlace = fg.valor;
        }
        this.carregandoService.esconde('buscarUsarMarketPlace');
      },
      (erro) => {
        this.carregandoService.esconde('buscarUsarMarketPlace');
        this.notificacaoService.erro(erro);
      },
    );
  }

  buscarPrecosFornecedores() {
    if (this.editando) {
      this.carregandoService.mostra('buscarPrecosFornecedores');
      this.produtoService.consultarPrecosFornecedores(this.idProduto).subscribe(
        (f) => {
          this.precosFornecedores = f;

          this.carregandoService.esconde('buscarPrecosFornecedores');
        },
        (erro) => {
          this.carregandoService.esconde('buscarPrecosFornecedores');
          this.notificacaoService.erro(erro);
        },
      );
    }
  }

  verificarSeExisteCodErpConector() {
    if (!this.produto.codErpConectorPainel || !this.produto.codErpConectorPainel.length) {
      this.produtoForm.form.controls['codErpConectorPainel'].setErrors();
      return;
    }

    this.carregandoService.mostra('verificarSeExisteCodErpConector');
    this.produtoService.consultarSeExisteProtudoCodErp(this.produto.codErpConectorPainel).subscribe(
      (p) => {
        this.produtoForm.form.controls['codErpConectorPainel'].setErrors(!p ? { incorrect: true } : undefined);
      },
      (err) => {
        this.notificacaoService.erro(err);
      },
      () => {
        this.carregandoService.esconde('verificarSeExisteCodErpConector');
      },
    );
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some((p) => p === modulo);
  }

  buscarModulosAtivos() {
    this.carregandoService.mostra('buscarModulosAtivos');

    this.premissasService.consultarModulosAtivos().subscribe(
      (dados) => {
        this.modulosAtivos = dados;
        this.carregandoService.esconde('buscarModulosAtivos');
      },
      (erro) => {
        this.carregandoService.esconde('buscarModulosAtivos');
        this.notificacaoService.erro(erro);
      },
    );
  }

  alterarValorFornecedor(valores: ProdutoFornecedorValor, tipo) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(AlterarMargemValorFornecedorModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: { valores: Object.assign({}, valores), tipo: tipo },
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarPrecosFornecedores();
      }
    });
  }

  novoValorFornecedor() {
    const valores = new ProdutoFornecedorValor();
    valores.idProduto = Number(this.idProduto);
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(ProdutoCDModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {
        valores: valores,
        cdsJaUsados:
          this.precosFornecedores !== null &&
          this.precosFornecedores !== undefined &&
          this.precosFornecedores.length > 0
            ? this.precosFornecedores.map((p) => p.idFornecedor)
            : [],
      },
      panelClass: 'modal-card',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarPrecosFornecedores();
      }
    });
  }

  defineTabAlvo(alvo) {
    this.tabAlvo = alvo;
  }

  toggleStatusItemFornecedor(item: ProdutoFornecedorValor) {
    this.carregandoService.mostra('toggleStatusItemFornecedor');
    this.produtoService
      .alterarSituacaoProdutoFornecedor(item.idProduto, item.idFornecedor, item.situacao === 'A' ? 'B' : 'A')
      .subscribe(
        () => {
          this.carregandoService.esconde('toggleStatusItemFornecedor');
          this.buscarPrecosFornecedores();
        },
        (err) => {
          this.carregandoService.esconde('toggleStatusItemFornecedor');
          this.notificacaoService.erro(err);
        },
      );
  }

  alterouCategoria() {
    if (this.editando) {
      if (this.produto.categoria !== 0 && this.produto.categoria !== null && this.produto.categoria !== undefined) {
        this.buscarClassificacoes();
      } else {
        this.produto.camposPersonalizadosMontar = [];
      }
    }
  }

  buscarClassificacoes() {
    this.carregandoService.mostra('buscarClassificacoes');

    this.produtoService.buscarClassificacoes(this.produto.camposPersonalizados, this.produto.categoria).subscribe(
      (valor) => {
        this.produto.camposPersonalizadosMontar = valor;
        this.carregandoService.esconde('buscarClassificacoes');
      },
      (erro) => {
        this.carregandoService.esconde('buscarClassificacoes');
        this.notificacaoService.erro(erro);
      },
    );
  }

  buscarPodeAlterarEstoque() {
    this.carregandoService.mostra('buscarPodeAlterarEstoque');

    this.funcionarioService.consultarPodeAlterarEstoque().subscribe(
      (valor) => {
        this.podeAlterarEstoque = valor;
        this.carregandoService.esconde('buscarPodeAlterarEstoque');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPodeAlterarEstoque');
        this.notificacaoService.erro(erro);
      },
    );
  }

  buscarUsarReservaManual() {
    this.carregandoService.mostra('consultarUsarReservaManual');

    this.premissasService.consultarUsarReservaManual().subscribe(
      (valor) => {
        this.usarReservaManual = valor;
        this.carregandoService.esconde('consultarUsarReservaManual');
      },
      (erro) => {
        this.carregandoService.esconde('consultarUsarReservaManual');
        this.notificacaoService.erro(erro);
      },
    );
  }

  // classificacaoPersonalizada() {
  //   const largura = Number(($('body').width()));

  //   const dialogRef = this.dialog.open(GerenciarClassificacaoPersonalizadaModalComponent, {
  //     width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
  //     data: {
  //       editavel: true,
  //       tabelas: this.produto.camposPersonalizadosMontar
  //     },
  //     panelClass: 'modal-card'
  //   });

  //   dialogRef.afterClosed().subscribe((result: any) => {
  //     if (result) {
  //       this.produto.camposPersonalizadosMontar = result;
  //     }
  //   });
  // }
  buscarUrlFoto(): string {
    if (this.produto.foto) {
      // Não usar string interpolation
      return 'data:image/jpg;base64,' + this.produto.foto;
    } else if (this.produto.fotoUrl) {
      return this.produto.fotoUrl;
    } else {
      return './assets/img/placeholder.jpg';
    }
  }

  possuiFoto(): boolean {
    return this.produto.foto || this.produto.fotoUrl;
  }
}
